module.exports = __webpack_public_path__ + "static/media/target-audience.26b3a1ad.svg";